import { useEffect, useSyncExternalStore } from "react";

import {
  ensureBrowseMenuLoaded,
  getBrowseMenuServerSnapshot,
  getBrowseMenuSnapshot,
  subscribeBrowseMenu,
  type BrowseMenuSnapshot,
} from "@/lib/browse-menu-client-fetch";
import type { BrowseMenuIndex, BrowseMenuNode } from "@/lib/browse-menu-tree";

export interface UseBrowseMenuReturn {
  roots: BrowseMenuNode[];
  index: BrowseMenuIndex | null;
  status: BrowseMenuSnapshot["status"];
  isLoading: boolean;
  error: string | null;
  ensureLoaded: typeof ensureBrowseMenuLoaded;
}

interface UseBrowseMenuOptions {
  enabled?: boolean;
}

const EMPTY_ROOTS: BrowseMenuNode[] = [];

export function useBrowseMenu(options: UseBrowseMenuOptions = {}): UseBrowseMenuReturn {
  const { enabled = true } = options;
  const snapshot = useSyncExternalStore(
    subscribeBrowseMenu,
    getBrowseMenuSnapshot,
    getBrowseMenuServerSnapshot
  );

  useEffect(() => {
    if (enabled) void ensureBrowseMenuLoaded().catch(() => {});
  }, [enabled]);

  return {
    roots: snapshot.index?.roots ?? EMPTY_ROOTS,
    index: snapshot.index,
    status: snapshot.status,
    isLoading: snapshot.status === "loading" || (enabled && snapshot.status === "idle"),
    error: snapshot.error,
    ensureLoaded: ensureBrowseMenuLoaded,
  };
}
